interface IconBatteryProps {
    className?: string;
    percentage?: number;
    isPluggedIn?: boolean;
}

const IconBattery = ({
    className,
    percentage = 100,
    isPluggedIn = false,
}: IconBatteryProps) => {
    const isError = percentage <= 19;
    const isWarning = percentage <= 39;

    const outlineClass =
        isError && !isPluggedIn ? "stroke-error-default" : "stroke-default/90";
    const barClass = isError
        ? "stroke-error-default animate-blink"
        : isWarning
        ? "stroke-warning-default"
        : "stroke-success-default";

    const batteryBars = [
        { threshold: -1, x: 4.5 },
        { threshold: 19, x: 7.5 },
        { threshold: 39, x: 10.5 },
        { threshold: 59, x: 13.5 },
        { threshold: 79, x: 16.5 },
    ];

    return (
        <svg
            className={className}
            width="24"
            height="14"
            viewBox="0 0 24 14"
            fill="none"
        >
            <path
                className={outlineClass}
                d="M20.25 4.25V3.75C20.25 2.95435 19.9339 2.19129 19.3713 1.62868C18.8087 1.06607 18.0456 0.75 17.25 0.75H3.75C2.95435 0.75 2.19129 1.06607 1.62868 1.62868C1.06607 2.19129 0.75 2.95435 0.75 3.75V10.25C0.75 11.0456 1.06607 11.8087 1.62868 12.3713C2.19129 12.9339 2.95435 13.25 3.75 13.25H17.25C18.0456 13.25 18.8087 12.9339 19.3713 12.3713C19.9339 11.8087 20.25 11.0456 20.25 10.25V9.75H21.75C22.1478 9.75 22.5294 9.59196 22.8107 9.31066C23.092 9.02936 23.25 8.64782 23.25 8.25V5.75C23.25 5.35218 23.092 4.97064 22.8107 4.68934C22.5294 4.40804 22.1478 4.25 21.75 4.25H20.25Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {!isPluggedIn ? (
                batteryBars.map(
                    ({ threshold, x }) =>
                        percentage > threshold && (
                            <path
                                key={x}
                                className={barClass}
                                d={`M${x} 3.75V10.25`}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        )
                )
            ) : (
                <path
                    className="fill-success-default"
                    d="M11.6127 11.5036V10.4508V9.39793H14.3501V8.3451H11.6127L11.6127 5.15851H14.3501V4.10567H11.6127V3.05284V2L10.5178 2V3.05284H7.76636C5.82914 3.05284 4.22883 4.42854 3.96211 6.22538L1.7301 6.22538L1.7301 7.27822L3.97615 7.27822C4.24287 9.07506 5.84318 10.4508 7.76636 10.4508L10.5178 10.4508V11.5036H11.6127Z"
                />
            )}
        </svg>
    );
};

export default IconBattery;
